import {layoutMarkup} from "../layout/layoutMarkup.js";
import {layoutPublicMarkup} from "../layout/layoutPublicMarkup";
import l10n from "../../../lang/locallang";

const choiceSection = (param, is_public = false) => {
    const { enterQuestion, questionLabel, enterText, isCorrect, addNewItem, submit } = l10n.editor;
    // Need for creating the different radio buttons groups for every section
    const randomNumber = Math.floor(Math.random() * 1000);
    param.class = param.class ? param.class : 'editor-section';
    param.content = param.content ? param.content : ``;
    param.style = param.style ? param.style : '';
    param.layout = param.layout ? param.layout : '';
    param.section = 'choiceSection';
    let question = param.content.question ? param.content.question : enterQuestion;
    let defaultList = {
        '1': {
            'id': 1,
            'option': `${questionLabel} 1`,
            'correct': 'true',
        },
        '2': {
            'id': 2,
            'option': `${questionLabel} 2`,
            'correct': 'false',
        }
    }

    let list = param.content.list ? param.content.list : defaultList;
    let listHtml = `<div class="multiple-choice-activity multiple-choice">
                <div class="multiple-choice-activity-question">
                    <span  ${!is_public ? `contenteditable="true" placeholder="${enterText}"` : ''}>${question}</span>
                </div>
                <div class="quiz-matching-result"></div>
                <div class="multiple-choice-activity not-submitted">`;
    for (let key in list) {
        listHtml += `
            <div class="multiple-choice-item" data-item="${key}" data-id="${list[key].id}">
                <label class="multiple-choice-item_correct radio-element">
                    <span class="radio-element-indicator">
                        <input type="radio" name="correct-answer-${randomNumber}" ${list[key].correct === true && !is_public ? `checked data-hint="${isCorrect}"` : '' }>
                        <span class="radio-element_icon"></span>
                    </span>
                    <div class="multiple-choice-item_content">
                        <span ${!is_public ? `contenteditable="true" placeholder="${enterText}"` : ''}>${list[key].option}</span>
                    </div>
                </label>
                ${!is_public ? `
                <div class="delete-el-button">
                    <button class="btn btn-delete-choice"><i class="icon icon-close-small"></i></button>
                </div>
                ` : ''}
            </div>`;
    }
    listHtml += `
                </div>
                ${!is_public ? `
                <div class="add-e-element-btn-wr">
                    <button class="btn add-e-element-btn btn-add-choice"><i class="icon icon-add"></i><span>${addNewItem}</span></button>
                </div>` : `
                <div class="add-e-element-btn-wr">
                    <button class="btn btn-orange btn-send lesson-submit-quiz" data-quiz="multiple-choice">${submit}</button>
                </div>
                `}
            </div>`;

    param.component = listHtml;
    if(is_public){
        return layoutPublicMarkup(param);
    } else {
        return layoutMarkup(param);
    }
}

export {choiceSection};
